import React, { useEffect, useState } from "react";
import { MdOutlineDelete } from "react-icons/md";
import { BsCheckCircleFill } from "react-icons/bs";
import { FaStar } from "react-icons/fa";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { IoClose } from "react-icons/io5";
import { Descriptions, Empty, message, Rate, Spin, Typography } from "antd";
import { Button } from "react-bootstrap";
import { HiDownload } from "react-icons/hi";
import { API_URL } from "../API/config";
import axios from "axios";
import moment from "moment";
import { TbReplace } from "react-icons/tb";
import type { RadioChangeEvent } from "antd";
import { Radio } from "antd";
import { Paper, Step, StepContent, StepLabel, Stepper } from "@mui/material";
import { LoadingOutlined } from "@ant-design/icons";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "10px",
};

const styleD = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "10px",
  height: "90%",
  overflowY: "scroll",
  scrollbarWidth: "none",
  msOverflowStyle: "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },
};
const styleC = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,

  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "10px",
  height: "60%",
  overflowY: "scroll",
  scrollbarWidth: "none",
  msOverflowStyle: "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },
};

const steps = [
  {
    label: "Order confirmed",
  },
  {
    label: "Order Shipped",
  },
  {
    label: "Out For Delivery",
  },
  {
    label: "Order Completed",
  },
];

interface Variant {
  variantName: string;
  storage: string;
  colorCode: string;
  colorName: string;
  ramSize: string;
  price: number;
  _id: string;
}

interface CartItem {
  variant: Variant;
  product: string;
  price: number;
  DeliveryType: string;
  _id: string;
}

interface WishlistItem {
  variant: Variant;
  product: string;
  price: number;
  _id: string;
}

interface User {
  _id: string;
  email: string;
  role: string;
  cart: CartItem[];
  wishlist: WishlistItem[];
  __v: number;
  termscondition: boolean;
  passwordChangedAt: string;
  firstName: string;
  lastName: string;
  position: string;
  shippingAddress: {
    addressType: string;
    alternateNumber: string;
    buildingAndBlockNumber: string;
    email: string;
    firstName: "John";
    houseNumberAndFloor: string;
    landmark: string;
    lastName: string;
    locality: string;
    phoneNumber: string;
    pincode: string;
  };
  ExchangeType: string;
}

const CurrentOrder = () => {
  const [isDetail, setIsDetail] = useState(false);
  type ShippingAddress = {
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    houseNumberAndFloor: string;
    buildingAndBlockNumber: string;
    locality: string;
    landmark: string;
    pincode: string;
  };

  type Order = {
    transactionId: string;
    _id: string;
    orderDate: string;
    paymentAmount: number;
    deliveryDate: string | null;
    paymentMethod: string;
    shippingAddress: ShippingAddress;
    products: Product[];
    exchange: boolean;
    deliveryType: string;
    productPrice: number;
    GSTInvoice: {
      isGSTEnabled: boolean;
    };
    isGst: boolean;
    gstAddress: any;
  };

  type Product = {
    id: string;
    name: string;
    quantity: number;
    price: number;
    productName: string;
    discountedPrice: number;
    colorName: string;
    storage: string;
    ramSize: string;
    productPrice: string;
    productImage: string;
  };

  const [viewData, setViewData] = useState<Order | null>(null);

  const handleDetailOpen = (data: any) => {
    console.log(data);

    setViewData(data);
    setIsDetail(true);
  };
  const handleDetailClose = () => setIsDetail(false);
  const [data, setData] = useState<any[]>([]);
  const [userData, setUserData] = useState<User | null>(null);
  const [conformOrder, setConformOrder] = useState<any[]>([]);
  const [deliveredOrder, setDeliveredOrder] = useState<any[]>([]);
  const [isCancel, setIsCancel] = useState({
    id: "",
    active: false,
    reason: "",
  });
  const [isReplacement, setIsReplacement] = useState({
    id: "",
    active: false,
    reason: "",
    pickupdate: "Weekday",
  });

  const [activeStep, setActiveStep] = useState(0);
  const [isTrack, setIsTrack] = useState({
    id: "",
    active: false,
  });

  const trackOrder = (val: any) => {
    if (val === "ordered") {
      setActiveStep(1);
    } else if (val === "shipping") {
      setActiveStep(2);
    } else if (val === "out for delivery") {
      setActiveStep(3);
    } else {
      setActiveStep(4);
    }
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const onChange = (e: RadioChangeEvent) => {
    setIsReplacement({ ...isReplacement, pickupdate: e.target.value });
  };

  const [ratingData, setRatingData] = useState({
    rate: 1,
    review: "",
    id: "",
    active: false,
  });
  const getUser = async () => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      message.error("Login required!");
      return;
    }

    try {
      const res = await axios.get(`${API_URL}/api/user/getMe`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setUserData(res.data.user);
      await getOrders(res.data.user._id);
    } catch (error: any) {
      console.log(error);
    }
  };

  const getOrders = async (id: any) => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      message.error("Login required!");
      return;
    }
    try {
      const res = await axios.get(`${API_URL}/api/orders/user/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setData(res.data.data.orders);
      const conformData = res.data.data.orders.filter(
        (val: any) =>
          val.status !== "completed" &&
          val.status !== "replaced" &&
          !val.isCancelled &&
          !val.replacedOrder
      );
      const completedData = res.data.data.orders.filter(
        (val: any) =>
          val.status == "completed" &&
          val.status !== "replaced" &&
          !val.isCancelled &&
          !val.replacedOrder
      );

      const currentOrdersWithImages = await Promise.all(
        conformData.map(async (order: any) => {
          const productsWithImages = await Promise.all(
            order.products.map(async (product: any) => {
              if (product.productId) {
                try {
                  const productResponse = await axios.get(
                    `${API_URL}/api/products/getById/${product.productId}`
                  );
                  return {
                    ...product,
                    productImage: productResponse.data.variants[0].images[0],
                  };
                } catch (err) {
                  console.warn(`Error fetching product image: ${err}`);
                  return { ...product, productImage: null };
                }
              } else {
                return { ...product, productImage: null };
              }
            })
          );
          return { ...order, products: productsWithImages };
        })
      );

      // Fetch product details for completed orders
      const completedOrdersWithImages = await Promise.all(
        completedData.map(async (order: any) => {
          const productsWithImages = await Promise.all(
            order.products.map(async (product: any) => {
              if (product.productId) {
                try {
                  const productResponse = await axios.get(
                    `${API_URL}/api/products/getById/${product.productId}`
                  );
                  return {
                    ...product,
                    productImage: productResponse.data.variants[0].images[0],
                  };
                } catch (err) {
                  console.warn(`Error fetching product image: ${err}`);
                  return { ...product, productImage: null };
                }
              } else {
                return { ...product, productImage: null };
              }
            })
          );
          return { ...order, products: productsWithImages };
        })
      );

      setConformOrder(currentOrdersWithImages.reverse());
      setDeliveredOrder(completedOrdersWithImages.reverse());
    } catch (error) {
      console.log(error);
    }
  };

  const cancelOrder = async (id: any) => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      message.error("Login required!");
      return;
    }
    try {
      const res = await axios.patch(
        `${API_URL}/api/orders/${isCancel.id}`,
        {
          isCancelled: true,
          cancellationReason: isCancel.reason,
          cancellationDate: new Date(),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setIsCancel({
        id: "",
        active: false,
        reason: "",
      });
      await getUser();
    } catch (error) {
      console.log(error);
    }
  };

  const handleReview = async () => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      message.error("Login required!");
      return;
    }

    try {
      const dta = {
        review: ratingData.review,
        rating: ratingData.rate,
        user: userData?._id,
        product: ratingData.id,
      };

      if (dta.review) {
        const res = await axios.post(`${API_URL}/api/review`, dta, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setRatingData({
          rate: 1,
          review: "",
          id: "",
          active: false,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const hanldereplacement = async () => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      message.error("Login required!");
      return;
    }
    try {
      const res = await axios.patch(
        `${API_URL}/api/orders/${isReplacement.id}`,
        {
          replacedOrder: true,
          replacedOrderReason: isReplacement.reason,
          PickupDate: isReplacement.pickupdate,
          replacementDate: new Date(),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setIsReplacement({
        id: "",
        active: false,
        reason: "",
        pickupdate: "Weekday",
      });
      await getUser();
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUser();
  }, []);

  if (conformOrder.length === 0 && deliveredOrder.length === 0) {
    return (
      <>
        <div className="text-center">
          <Spin className="custom-spinner" />
        </div>
      </>
    );
  }

  return (
    <>
      <section>
        {conformOrder.length > 0 || deliveredOrder.length > 0 ? (
          <div className="order-padd">
            {conformOrder.map((val, i) => {
              const orderDate = new Date(val.orderDate).getTime();
              const now = new Date().getTime();
              const twoHoursInMs = 2 * 60 * 60 * 1000;
              const isCancellable = now - orderDate <= twoHoursInMs;
              return (
                <div className="row py-2">
                  <div className="col-lg-1 col-md-1 col-sm-3 col-3">
                    <div>
                      <img
                        className="img-fluid order-img"
                        src={val.products[0].productImage}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-3 col-sm-9 col-9">
                    <div>
                      <h3 className="order-head">
                        {val.products[0].productName || ""}{" "}
                        {`${val.products[0].ramSize || ""},${
                          val.products[0].storage || ""
                        },${val.products[0].colorName || ""}`}
                      </h3>
                      <span
                        style={{
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                        onClick={() => setIsTrack({ ...isTrack, active: true })}
                      >
                        <a onClick={() => trackOrder(val.status)}>
                          Track Order
                        </a>
                      </span>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-3 d-flex justify-content-center">
                    <div className="order-price">
                      <p>₹ {val.paymentAmount.toFixed(2)}</p>
                      <span
                        className=""
                        style={{
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                        onClick={() => handleDetailOpen(val)}
                      >
                        View detail
                      </span>{" "}
                      <br />
                      {/* <span>{val.status}</span> */}
                    </div>
                  </div>
                  <div className="col-lg-5">
                    <div className="order-deliv">
                      <p>
                        Expected Delivery on{" "}
                        {moment(val.deliveryDate).format("ddd DD-MM-YYYY")}{" "}
                        <BsCheckCircleFill
                          className="ms-3 mb-1"
                          style={{ color: "#E30000", fontSize: "20px" }}
                        />
                      </p>
                      {isCancellable ? (
                        <div className="canel-btn">
                          <a
                            onClick={() =>
                              setIsCancel({
                                ...isCancel,
                                id: val._id,
                                active: true,
                              })
                            }
                          >
                            Cancel order{" "}
                            <MdOutlineDelete style={{ fontSize: "20px" }} />
                          </a>
                          <p className="mb-0">
                            ( Cancel before the 2 hr from order confirm )
                          </p>
                        </div>
                      ) : (
                        <p className="mb-0">Cancellation period has expired.</p>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}

            <hr />
            {deliveredOrder.map((val, i) => (
              <div className="row">
                <div className="col-lg-1 col-md-1 col-sm-3 col-3">
                  <div>
                    <img
                      className="img-fluid order-img"
                      src={val.products[0].productImage}
                    />
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-9 col-9">
                  <div>
                    <h3 className="order-head">
                      {val.products[0].productName || ""}{" "}
                      {`${val.products[0].ramSize || ""},${
                        val.products[0].storage || ""
                      },${val.products[0].colorName || ""}`}
                    </h3>
                    <a
                      className="review-order pb-2"
                      style={{ textDecoration: "underline" }}
                      onClick={() =>
                        setRatingData({
                          ...ratingData,
                          id: val.products[0].productId,
                          active: true,
                        })
                      }
                    >
                      <FaStar className="star-orsder" />
                      Review & Rating{" "}
                    </a>
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 d-flex justify-content-center">
                  <div className="order-price">
                    <p>₹ {val.paymentAmount.toFixed(2)}</p>
                    <span
                      style={{ textDecoration: "underline", cursor: "pointer" }}
                      onClick={() => handleDetailOpen(val)}
                    >
                      View detail
                    </span>
                  </div>
                </div>
                <div className="col-lg-5">
                  <div className="order-deliv">
                    <p>
                      Delivered on{" "}
                      {moment(val.deliveryDate).format("DD dd-mm-yyyy")}{" "}
                      <BsCheckCircleFill
                        className="ms-3 mb-1"
                        style={{ color: "#2FB300", fontSize: "20px" }}
                      />
                    </p>

                    <div className="canel-btn">
                      <a
                        onClick={() =>
                          setIsReplacement({
                            ...isReplacement,
                            id: val._id,
                            active: true,
                          })
                        }
                      >
                        Replacement <TbReplace style={{ fontSize: "20px" }} />
                      </a>
                      <p className="mb-0">
                        (Replace within 7days after the order receive.)
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <Empty description="No items found" />
        )}
      </section>

      {/* Rating model */}
      <div>
        <Modal
          open={ratingData.active}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <div className="d-flex justify-content-between align-items-center">
              <h3 className="ratr-head">Review & Rating</h3>
              <IoClose
                style={{ fontSize: "20px", cursor: "pointer" }}
                onClick={() => setRatingData({ ...ratingData, active: false })}
              />
            </div>
            <div className="rateig">
              <label>
                Rating <span style={{ color: "red" }}>*</span>
              </label>
              <br />
              <Rate
                value={ratingData.rate}
                onChange={(value) =>
                  setRatingData({ ...ratingData, rate: value })
                }
              />
              <br />
              <label>
                Review <span style={{ color: "red" }}>*</span>
              </label>
              <br />
              <textarea
                className="p-2"
                rows={4}
                onChange={(e) =>
                  setRatingData({ ...ratingData, review: e.target.value })
                }
              ></textarea>
              <br />
              <div className="text-center pt-3">
                <Button onClick={handleReview}>Save</Button>
              </div>
            </div>
          </Box>
        </Modal>
      </div>

      {/* Detail model */}
      <Modal
        open={isDetail}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleD}>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="ratr-head">Order Detail</h3>
            {viewData?.GSTInvoice?.isGSTEnabled && (
              <div>
                <p>
                  GST Invoice
                  <HiDownload
                    className="me-3"
                    style={{ fontSize: "20px", cursor: "pointer" }}
                  />
                </p>
              </div>
            )}
            <IoClose
              style={{ fontSize: "20px", cursor: "pointer" }}
              onClick={handleDetailClose}
            />
          </div>
          {viewData && (
            <>
              <div className="row pt-4">
                <div className="col-lg-8 col-md-8 col-sm-12 col-12">
                  <div className="detail-s py-2">
                    <h5>Shipping Detail</h5>
                    {viewData.isGst ? (
                      <>
                        <p>
                          <span>
                            {`${viewData.gstAddress.firstName} ${viewData.gstAddress.lastName}`}
                          </span>
                          , {viewData.gstAddress.email},{" "}
                          {viewData.gstAddress.phoneNumber}
                        </p>

                        <p>
                          {[
                            viewData.gstAddress.houseNumberAndFloor,
                            viewData.gstAddress.buildingAndBlockNumber,
                            viewData.gstAddress.locality,
                            viewData.gstAddress.landmark,
                            viewData.gstAddress.pincode,
                          ]
                            .filter(Boolean)
                            .join(", ")}
                        </p>
                        <p>
                          <strong>GST Number</strong>:
                          {viewData.gstAddress.gstNumber}
                        </p>
                        <p>
                          <strong>Business Name</strong>:
                          {viewData.gstAddress.businessName}
                        </p>
                      </>
                    ) : (
                      <>
                        <p>
                          <span>
                            {`${viewData.shippingAddress.firstName} ${viewData.shippingAddress.lastName}`}
                          </span>
                          , {viewData.shippingAddress.email},{" "}
                          {viewData.shippingAddress.phoneNumber}
                        </p>
                        <p>
                          {[
                            viewData.shippingAddress.houseNumberAndFloor,
                            viewData.shippingAddress.buildingAndBlockNumber,
                            viewData.shippingAddress.locality,
                            viewData.shippingAddress.landmark,
                            viewData.shippingAddress.pincode,
                          ]
                            .filter(Boolean)
                            .join(", ")}
                        </p>
                      </>
                    )}
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12 col-12">
                  <div className="detaisl-order py-2">
                    <h5>Order Detail</h5>
                    <p>
                      <span>Order date:</span>{" "}
                      {moment(viewData.orderDate).format("DD-MM-YYYY")}
                    </p>
                    <p>
                      <span>Order ID:</span> {viewData._id.slice(-5) || "-"}
                    </p>
                    <p>
                      <span>Order total:</span> ₹{" "}
                      {viewData.paymentAmount || "-"}
                    </p>
                    <p>
                      <span>Expected delivery:</span>{" "}
                      {viewData.deliveryDate
                        ? moment(viewData.deliveryDate).format("DD-MM-YYYY")
                        : "-"}
                    </p>
                    <p>
                      <span>Payment:</span> {viewData.paymentMethod || "-"}
                    </p>
                    {viewData.transactionId && (
                      <p>
                        <span>TransactionID:</span>{" "}
                        {viewData.transactionId || "-"}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              {viewData.products.map((product, index) => (
                <div key={index} className="row orer-q pt-4">
                  <div className="col-lg-4 col-md-4 col-sm-6 col-6">
                    <div className="text-start">
                      <img className="img-fluid" src={product.productImage} />
                      <p className="ps-3">Qt: {product.quantity || 1}</p>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-6 col-6">
                    <div>
                      <h3>{`${
                        product.productName ? product.productName : ""
                      } (${product.ramSize ? product.ramSize : ""}${
                        product.storage ? "," + product.storage : ""
                      } ${
                        product.colorName ? "," + product.colorName : ""
                      })`}</h3>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-4 col-sm-12 col-12">
                    <div>
                      <h3>₹ {product.productPrice || ""}</h3>
                      <p>
                        {viewData.deliveryType === "Express"
                          ? "Express delivery"
                          : "Standard delivery"}{" "}
                        with{" "}
                        {viewData.exchange ? "exchange" : "with out exchange"}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </>
          )}
        </Box>
      </Modal>

      {/* Cancel model */}
      <div>
        <Modal
          open={isCancel.active}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={styleC}>
            <div className="d-flex justify-content-between align-items-center">
              <h3 className="ratr-head">Cancellation Reason:</h3>
              <div>
                <p>
                  <IoClose
                    style={{ fontSize: "20px", cursor: "pointer" }}
                    onClick={() =>
                      setIsCancel({ ...isCancel, active: false, id: "" })
                    }
                  />
                </p>
              </div>
            </div>
            <textarea
              className="p-2"
              style={{ border: "1px solid #000", width: "100%" }}
              rows={5}
              onChange={(e) =>
                setIsCancel({ ...isCancel, reason: e.target.value })
              }
            ></textarea>
            <div className="text-center pt-3">
              <Button
                variant="contained"
                className="save"
                onClick={cancelOrder}
              >
                Save
              </Button>
            </div>
          </Box>
        </Modal>
      </div>

      {/* Replace model */}
      <div>
        <Modal
          open={isReplacement.active}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={styleD}>
            <div className="d-flex justify-content-between align-items-center">
              <h3 className="ratr-head">Replacement </h3>
              <div>
                <p>
                  <IoClose
                    style={{ fontSize: "20px", cursor: "pointer" }}
                    onClick={() =>
                      setIsReplacement({
                        ...isReplacement,
                        active: false,
                        id: "",
                      })
                    }
                  />
                </p>
              </div>
            </div>
            <label className="pb-2">
              Why are you replacing this<span style={{ color: "red" }}>*</span>
            </label>
            <br />
            <textarea
              onChange={(e) =>
                setIsReplacement({ ...isReplacement, reason: e.target.value })
              }
              className="p-2"
              rows={4}
              style={{
                width: "100%",
                border: "1px solid #000",
                borderRadius: "8px",
              }}
            ></textarea>
            <label className="pb-2">
              Pickup date<span style={{ color: "red" }}>*</span>
            </label>
            <br />
            <Radio.Group onChange={onChange} value={isReplacement.pickupdate}>
              <Radio value={"Weekday"}>Weekday</Radio>
              <Radio value={"Weekend"}>Weekend</Radio>
            </Radio.Group>
            <div className="text-center pt-3">
              <Button
                variant="contained"
                className="save"
                onClick={hanldereplacement}
              >
                Confirm
              </Button>
            </div>
          </Box>
        </Modal>
      </div>

      {/* Order Track */}
      <div>
        <Modal
          open={isTrack.active}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <div className="d-flex justify-content-between align-items-center">
              <h3 className="ratr-head">Track Order</h3>
              <div>
                <p>
                  <IoClose
                    style={{ fontSize: "20px", cursor: "pointer" }}
                    onClick={() =>
                      setIsTrack({
                        ...isTrack,
                        active: false,
                        id: "",
                      })
                    }
                  />
                </p>
              </div>
            </div>
            <Box sx={{ maxWidth: 400 }}>
              <Stepper activeStep={activeStep} orientation="vertical">
                {steps.map((step, index) => (
                  <Step key={step.label}>
                    <StepLabel>{step.label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Box>
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default CurrentOrder;
